import LaurentMekies from "./laurent_mekies.webp"
import GianPieroLambiase from "./gianpiero_lambiase.webp"
import PierreWache from "./pierre_wache.webp"
import RichardWolverson from "./richard_wolverson.webp"
import HannahSchmitz from "./hannah_schmitz.webp"
import RichardWood from "./richard_wood.webp"
import StephenKnowles from "./stephen_knowles.webp"

export const pictures = {
	LaurentMekies,
	GianPieroLambiase,
	PierreWache,
	RichardWolverson,
	HannahSchmitz,
	RichardWood,
	StephenKnowles,
}
